import { useLocation, useNavigate } from "react-router-dom";
import { langFromPath, localizedPath } from "./lang";

/** navigate() that keeps the current language prefix: "/account" becomes "/de/account" on a German page. */
export function useLocalizedNavigate() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (path: string) => navigate(localizedPath(path, langFromPath(pathname).code));
}
